import Markdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'
import rehypeSanitize from 'rehype-sanitize'

export const Container = ({ article }) => {
  return (
    <>
      <section className="embed-responsive embed-responsive-16by9 mt-4 mb-4">
        <iframe
          className="embed-responsive-item"
          src={`https://www.youtube.com/embed/${article.videoId}?rel=0`}
          allowFullScreen
          title={article.title}
        />
      </section>
      {article.content.map(row => <Markdown key={row} rehypePlugins={[rehypeRaw, rehypeSanitize]}>{row}</Markdown>)}
    </>
  )
}